var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-checkbox',_vm._b({attrs:{"checked":_vm.newChecked},on:{"change":_vm.changeValue}},'a-checkbox',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }